import { render, staticRenderFns } from "./AbkContentPreview.vue?vue&type=template&id=13574712&scoped=true&"
import script from "./AbkContentPreview.vue?vue&type=script&lang=js&"
export * from "./AbkContentPreview.vue?vue&type=script&lang=js&"
import style0 from "./AbkContentPreview.vue?vue&type=style&index=0&id=13574712&lang=scss&scoped=true&"
import style1 from "./AbkContentPreview.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13574712",
  null
  
)

export default component.exports